module.exports = __webpack_public_path__ + "static/media/login-with-facebook.9662a75f.png";